import React from 'react';
import {clsx} from 'clsx';

import tallyStyle from './icon.module.styl';

const UsersTallyIcon = ({className}: {className: string}) => {
  return (
    <div className={clsx(className, tallyStyle.iconContainer)}>
      <svg width='40' height='40' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g>
          {/* Static gray background circle */}
          <circle
            className={tallyStyle.staticStroke}
            cx='30'
            cy='30'
            r='28'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
          />

          {/* Rotating purple segments (visible when not loaded) */}
          <g className={tallyStyle.spinner}>
            <path
              className={tallyStyle.spinnerStroke}
              d='M30 2 A28 28 0 0 1 58 30'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <path
              className={tallyStyle.spinnerStroke}
              d='M30 58 A28 28 0 0 1 2 30'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </g>

          {/* Complete purple circle (visible when loaded) */}
          <circle
            className={tallyStyle.iconCircle}
            cx='30'
            cy='30'
            r='28'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
          />

          {/* Replays icon (always visible) */}
          <g className={tallyStyle.icon}>
            <path
              className={tallyStyle.iconPathFill}
              d='M8.5 5.25C10.2949 5.25 11.7499 6.7051 11.75 8.5C11.75 9.37459 11.4027 10.1667 10.8408 10.751C12.5399 11.5173 13.75 13.0947 13.75 15C13.75 15.4142 13.4142 15.75 13 15.75C12.5858 15.75 12.25 15.4142 12.25 15C12.25 13.2857 10.6566 11.75 8.5 11.75C6.34345 11.75 4.75 13.2857 4.75 15C4.75 15.4142 4.41421 15.75 4 15.75C3.58579 15.75 3.25 15.4142 3.25 15C3.25 13.095 4.45958 11.5174 6.1582 10.751C5.59661 10.1667 5.25 9.37434 5.25 8.5C5.25008 6.7051 6.70508 5.25 8.5 5.25ZM14 6.25C15.6097 6.25 16.75 7.70676 16.75 9.28613C16.7499 9.91159 16.633 10.4516 16.3486 10.9258C16.3004 11.0063 16.2465 11.0813 16.1914 11.1543C17.7212 11.7907 18.75 13.2722 18.75 15C18.75 15.4142 18.4142 15.75 18 15.75C17.5858 15.75 17.25 15.4142 17.25 15C17.25 13.7034 16.3551 12.6207 15.0654 12.374L14.8027 12.3359C14.3655 12.2927 14.1213 11.9593 14.0518 11.6836C13.982 11.4067 14.0396 10.9889 14.418 10.7461L14.6484 10.5859C14.8517 10.4327 14.9782 10.2949 15.0625 10.1543C15.1704 9.97422 15.2499 9.72099 15.25 9.28613C15.25 8.34078 14.5994 7.75 14 7.75C13.5858 7.75 13.25 7.41421 13.25 7C13.25 6.58579 13.5858 6.25 14 6.25ZM8.5 6.75C7.53359 6.75 6.75008 7.53345 6.75 8.5C6.75 9.45743 7.51905 10.2354 8.47266 10.25H8.52734C9.48095 10.2354 10.25 9.45742 10.25 8.5C10.2499 7.53345 9.46641 6.75 8.5 6.75Z'
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export {UsersTallyIcon};
